/* Keep Impact's outer disclosure, outside-click and Escape behavior. */
(() => {
  const init = () => document.querySelectorAll('[data-product-menu]').forEach(menu => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    const summary = menu.querySelector(':scope > summary');
    const surface = menu.querySelector('.inventa-product-menu__surface');
    const buttons = [...menu.querySelectorAll('[data-product-category]')];
    const panels = [...menu.querySelectorAll('[data-product-panel]')];
    let leaveTimer;
    const fit = () => {
      const rect = menu.getBoundingClientRect();
      const width = Math.min(780, innerWidth - 48);
      surface.style.setProperty('--product-menu-shift', `${Math.min(0, innerWidth - 24 - rect.left - width)}px`);
      surface.style.setProperty('--product-menu-height', `${Math.max(160, innerHeight - rect.bottom - 36)}px`);
    };
    const activate = button => {
      const id = button.getAttribute('aria-controls');
      buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
      panels.forEach(panel => panel.hidden = panel.id !== id);
    };
    buttons.forEach(button => {
      button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') activate(button); });
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault(); activate(button);
          panels.find(panel => !panel.hidden)?.querySelector('a')?.focus();
        }
      });
    });
    menu.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(leaveTimer); fit(); menu.open = true;
    });
    menu.addEventListener('pointerleave', event => {
      if (event.pointerType === 'mouse') leaveTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 250);
    });
    menu.addEventListener('toggle', () => { summary.setAttribute('aria-expanded', String(menu.open)); if (menu.open) fit(); });
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; summary.focus(); } });
    summary.addEventListener('click', event => {
      event.preventDefault(); event.stopImmediatePropagation();
      clearTimeout(leaveTimer); fit(); menu.open = true;
    }, true);
    document.addEventListener('pointerdown', event => {
      if (menu.open && !menu.contains(event.target)) { clearTimeout(leaveTimer); menu.open = false; }
    });
    window.addEventListener('resize', fit);
    fit();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
